import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FactCheckIcon from '@mui/icons-material/FactCheck';

const Preparations = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            <div style={{ width: '80%', display: 'flex', margin:'auto', marginTop:'1rem', marginBottom:'1rem'}}>
                <FactCheckIcon style={{ color: '#10609e' }} />
                <p style={{ width: '80%', marginTop: '3px', marginLeft:'1rem', fontWeight:'bold', color:'#10609e'  }}>Preparations for conducting the study:</p><br />
            </div>
            <Accordion className='accordian_members' expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0}}>
                            Where do I find the protocol manual and other research documents?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <ul style={{ listStyleType: 'none' }}>
                                <li>They can be found in the CloudStor folders for each study:</li><br />
                                <li data-text="Pilot study: ">https://cloudstor.aarnet.edu.au/plus/s/iBIEI8l7GSzed4t</li>
                                <li data-text="Main study: ">https://cloudstor.aarnet.edu.au/plus/s/veBYpv7AOkEG6Ml</li>
                            </ul>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion className='accordian_members' expanded={expanded === 'panel2'} onChange={handleChange('panel2')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                    >
                        <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>Do I need to prepare translations of all documents in my country’s language/s?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <p>The documents in the CloudStor folder called “Documents to be Translated” are required to be translated by your team if English is not freely
                                spoken/written in your country. These documents have been translated into various languages for other countries (e.g., French and Spanish).
                                Before translating the protocol documents, please check with the Coordinating Centre whether translations already exist for the primary language
                                spoken within your country. If translations do not already exist for the appropriate language, the translations need to be completed by a member
                                of the participating country at least one month prior to the training taking place within in their country. This timeline is important as it
                                ensures that the Coordinating Centre has enough time to prepare the data collection tools for the training.</p>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion className='accordian_members' expanded={expanded === 'panel3'} onChange={handleChange('panel3')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4bh-content"
                        id="panel4bh-header"
                    >
                        <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What equipment is required?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography >
                            <ul style={{ listStyleType: 'none' }}>
                                <li>High-income countries are required to independently procure the necessary equipment for data collection. For low- and
                                    middle-income countries, the equipment can be loaned by the SUNRISE Coordinating Centre.</li><br />
                                <li>The equipment required includes:</li>
                                <ul style={{ marginLeft: '2rem', listStyleType: 'disc' }}>
                                    <li>A portable stadiometer and electronic scales,</li>
                                    <li>Two iPads with the Early Years Toolbox games (Mr Ant and Go/No-Go) installed,</li>
                                    <li>One 9-hole pegboard,</li>
                                    <li>One handgrip dynamometer, and,</li>
                                    <li>ActiGraph accelerometers.</li>
                                </ul>
                            </ul>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion className='accordian_members' expanded={expanded === 'panel4'} onChange={handleChange('panel4')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4bh-content"
                        id="panel4bh-header"
                    >
                        <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What approvals are required before we can conduct the training and data collection for the SUNRISE Study?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography >
                            <ul style={{ listStyleType: 'none' }}>
                                <li>You will need to complete a Collaboration Agreement with the University of Wollongong, Australia.</li><br />
                                <li>You will also need to obtain ethics approval from your institution’s research board or appropriate ethical committee. This approval will need
                                    to be shared with the UOW Coordinating Centre and submitted to the University of Wollongong’s Human Research Ethical Committee. If you acquire
                                    approval from government organisations or Early Childhood Education and Care Centres, these will also need to be shared with the UOW Coordinating
                                    Centre.</li><br />
                                <li>It is important to note that the specific approvals required may vary between countries. Therefore, it is the responsibility of the chief
                                    investigators within each country to stay informed about the specific approval processes and requirements applicable in their country and
                                    institution.</li>
                            </ul>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion className='accordian_members' expanded={expanded === 'panel5'} onChange={handleChange('panel5')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4bh-content"
                        id="panel4bh-header"
                    >
                        <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>Who will train my team in the SUNRISE Protocol?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography >
                            A member of the SUNRISE Leadership group or the Coordinating Centre at the University of Wollongong, Australia, will provide training for each country
                            when they are ready to collect data. This is conducted over two days and includes a visit to a local preschool to practice assessments with children and
                            staff. High-income countries are requested to fund accommodation and airport transfers for a member of the SUNRISE Team to conduct the training. For LMICs,
                            the SUNRISE coordinating centre will cover this cost.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
        </>
    )
}

export default Preparations
